import { useHasSavedReportsQuery } from '../schema'

export function useHasSavedReports() {
  const { data } = useHasSavedReportsQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })
  return data?.viewer?.savedReports.totalCount && data.viewer.savedReports.totalCount > 0
}
